import { ChevronDown, ChevronUp, Rocket, ShieldCheck } from 'lucide-react';
import React, { useState } from 'react';
import CurrencyText from '../../../components/ui/labels/CurrencyText';
import useIsMobile from '../../../components/hooks/useIsMobile';

const ProtectionsTab = ({ lifeProtections, disabilityProtections }) => {
  const [showLife, setShowLife] = useState(true);
  const [showDisability, setShowDisability] = useState(false);

  const handleToggleLife = () => {
    setShowLife(!showLife);
  };

  const handleToggleDisability = () => {
    setShowDisability(!showDisability);
  };

  const isMobile = useIsMobile(1024);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between cursor-pointer items-center" onClick={handleToggleLife}>
        <h2 className="text-lg text-blueDarker font-semibold">Coberturas por Morte ({lifeProtections.length})</h2>
        {showLife ? (
          <ChevronUp className="text-blueDarker rotate-180 cursor-pointer" size={20} strokeWidth={1.5} />
        ) : (
          <ChevronDown className="text-blueDarker cursor-pointer" size={20} strokeWidth={1.5} />
        )}
      </div>

      {showLife && (
        <div className="flex flex-col gap-5">
          {lifeProtections.length === 0 ? (
            <></>
          ) : (
            lifeProtections.map((protection) => (
              <div
                key={protection.id}
                className={`flex rounded-custom20 p-4 bg-blueLight ${
                  isMobile ? 'flex-col' : 'flex-row justify-between items-center'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="rounded-full bg-tealMedium text-white w-8 h-8 flex items-center justify-center">
                    <ShieldCheck className="text-white inline-block" size={18} strokeWidth={1.5} />
                  </span>
                  <h3 className="text-lg font-semibold text-blueDarker">{protection.name}</h3>
                </div>
                <div className={`flex flex-col ${isMobile ? 'items-center text-center' : 'text-right items-end'}`}>
                  <CurrencyText value={protection.coverageValue} size="xSmall" className="" color="blueDarker" />
                </div>
              </div>
            ))
          )}
        </div>
      )}

      <div className="flex justify-between cursor-pointer items-center" onClick={handleToggleDisability}>
        <h2 className="text-lg text-blueDarker font-semibold">Coberturas em Vida ({disabilityProtections.length})</h2>
        {showDisability ? (
          <ChevronUp className="text-blueDarker rotate-180 cursor-pointer" size={20} strokeWidth={1.5} />
        ) : (
          <ChevronDown className="text-blueDarker cursor-pointer" size={20} strokeWidth={1.5} />
        )}
      </div>

      {showDisability && (
        <div className="flex flex-col gap-5">
          {disabilityProtections.length === 0 ? (
            <></>
          ) : (
            disabilityProtections.map((protection) => (
              <div
                key={protection.id}
                className={`flex rounded-custom20 p-4 bg-blueLight ${
                  isMobile ? 'flex-col' : 'flex-row justify-between items-center'
                }`}
              >
                <div className="flex items-center gap-3">
                  <span className="rounded-full bg-tealMedium text-white w-8 h-8 flex items-center justify-center">
                    <ShieldCheck className="text-white inline-block" size={18} strokeWidth={1.5} />
                  </span>
                  <h3 className="text-lg font-semibold text-blueDarker">{protection.name}</h3>
                </div>
                <div className={`flex flex-col ${isMobile ? 'items-center text-center' : 'text-right items-end'}`}>
                  <CurrencyText value={protection.coverageValue} size="xSmall" className="" color="blueDarker" />
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default ProtectionsTab;
